import { render, staticRenderFns } from "./EditPersonRoleContract.vue?vue&type=template&id=851ab620&scoped=true"
import script from "./EditPersonRoleContract.vue?vue&type=script&lang=js"
export * from "./EditPersonRoleContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851ab620",
  null
  
)

export default component.exports